import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 font-bold">
            探索仙尊世界
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大板块，全方位呈现大爱仙尊的传奇宇宙
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative p-6 md:p-7 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                  <i className={`${cat.icon} text-xl text-primary-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base md:text-lg font-heading text-foreground-900 font-semibold mb-2 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                    {cat.description}
                  </p>
                  <span className="text-xs text-foreground-500">
                    {cat.articleCount} 篇文章
                  </span>
                </div>
              </div>
              <div className="absolute bottom-6 right-6 w-8 h-8 rounded-full bg-background-200/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-2 group-hover:translate-x-0">
                <i className="ri-arrow-right-line text-sm text-primary-600"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}